<template>
	<div class="bar">
		<div class="bar_logo">
			<img class="bar_logo_img" src="../static/home/logo.png" alt="">
		</div>
		<div class="bar_text">
			<div class="bar_name">
				<span v-if="lang==1">陕甘茶马古道景区  景区最大游客承载量：18170人</span>
				<span v-if="lang==2">tea-horse road</span>
				<span v-if="lang==3">陝甘茶馬古道観光地</span>
				<span v-if="lang==4">섬감차마고도 관광지</span>
			</div>
			<div class="bar_option">
				<div class="bar_minopt" @click="barfun(0)">
					<span v-if="lang==1">虚拟景区</span>
					<span v-if="lang==2">Virtual</span>
					<span v-if="lang==3">仮想観光地</span>
					<span v-if="lang==4">가상 관광지</span>
				</div>
				<div class="bar_minopt" @click="barfun(1)">
					<span v-if="lang==1">茶马古道景点</span>
					<span v-if="lang==2">Attractions</span>
					<span v-if="lang==3">スポット</span>
					<span v-if="lang==4">관광지</span>
				</div>
				<div class="bar_minopt" @click="barfun(2)">
					<span v-if="lang==1">旅游指南</span>
					<span v-if="lang==2">Scenic Spots</span>
					<span v-if="lang==3">観光スポット</span>
					<span v-if="lang==4">관광지</span>
				</div>
				<div class="bar_minopt" @click="barfun(3)">
					<span v-if="lang==1">服务中心</span>
					<span v-if="lang==2">service center</span>
					<span v-if="lang==3">サービスセンター</span>
					<span v-if="lang==4">서비스 센터</span>
				</div>
				<div class="bar_minopt" @click="barfun(4)">
					<span v-if="lang==1">联系方式</span>
					<span v-if="lang==2">contact</span>
					<span v-if="lang==3">連絡先</span>
					<span v-if="lang==4">연락처</span>
				</div>
			</div>
			<div class="bar_website">
				CopyRight © 2023 shanganchamagudao All Rights Reserved.Design 
			</div>
			<div class="bar_jszc">
				<span v-if="lang==1"><span @click="rescue()">by: 至上互动 </span> <span @click="ban()">ICP:陕ICP备2021001518号-3</span></span>
				<span v-if="lang==2"><span @click="rescue()">By: Supreme Interactive </span> <span @click="ban()">ICP: 陕ICP备2021001518号-3</span></span>
				<span v-if="lang==3"><span @click="rescue()">by：上インタラクティブ</span> <span @click="ban()">ICP：陕ICP备2021001518号-3</span></span>
				<span v-if="lang==4"><span @click="rescue()">by: 지상 인터랙티브 </span> <span @click="ban()">ICP: 陕ICP备2021001518号-3</span></span>
			</div>
		</div>
		<div class="bar_phone">
			<div class="bar_ertextbox">
				<div class="bar_ertext">
					<span v-if="lang==1">【扫一扫 关注微信公众号】</span>
					<span v-if="lang==2">【Scan to follow WeChat】</span>
					<span v-if="lang==3">【注目の微信をスキャンする】</span>
					<span v-if="lang==4">【위챗 대중번호를 훑어보다】</span>
				</div>
				<img class="san" src="../static/home/san.png" alt="">
			</div>
			<div class="bar_address">
				<span v-if="lang==1">景区地址：陕西省安康市紫阳县陕甘茶马古道景区</span>
				<span v-if="lang==2">Scenic Area Address: tea-horse road</span>
				<span v-if="lang==3">観光地住所：陝西省安康市紫陽県茶馬古道</span>
				<span v-if="lang==4">관광지 주소: 섬서성 안강시 자양현 다마고도</span>
			</div>
			<div class="bar_phone_num">
				<div class="bar_phone_box">
					<span v-if="lang==1">咨询电话：0915-4423555</span>
					<span v-if="lang==2">advice：0915-4423555</span>
					<span v-if="lang==3">コンサルティング：0915-4423555</span>
					<span v-if="lang==4">문의 전화：0915-4423555</span>
				</div>
				<div class="bar_phone_box">
					<span v-if="lang==1">救援电话：0915-4423555 </span>
					<span v-if="lang==2">Rescue：0915-4423555 </span>
					<span v-if="lang==3">救援電話：0915-4423555 </span>
					<span v-if="lang==4">구조 전화：0915-4423555 </span>
				</div>
				<div class="bar_phone_box_z">
					<span v-if="lang==1">投诉电话：0915-2280004</span>
					<span v-if="lang==2">Complaints：0915-2280004</span>
					<span v-if="lang==3">クレーム電話：0915-2280004</span>
					<span v-if="lang==4">신고 전화：0915-2280004</span>
				</div>
			</div>
			<div class="bar_supervise" @click="nuv()">
				<span v-if="lang==1">全国旅游监管服务平台：12345</span>
				<span v-if="lang==2">Tourism Supervision：12345</span>
				<span v-if="lang==3">サービスプラットフォーム：12345</span>
				<span v-if="lang==4">전국 관광 감독 관리 서비스 플랫폼：12345</span>
			</div>
		</div>
		<div class="bar_er">
			<img class="bar_erimg" src="../static/home/er_1.png" alt="">
		</div>
		
		
		
		<!--  -->
		<div class="riesun" v-if="riesunfalg" @click="close()">
			<div class="riesun_box">
				<img class="riesun_img" src="../static/home/riesun.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				lang:1,	//语言
				riesunfalg:false,
			}
		},
		created() {
			this.lang = JSON.parse(localStorage.getItem("langs")) || 1
		},
		methods:{
			nuv(){
				window.open('https://jbts.mct.gov.cn/',"_blank");
			},
			ban(){
				window.open('https://beian.miit.gov.cn',"_blank");
			},
			// 名片
			rescue(){
				this.riesunfalg = true
			},
			close(){
				this.riesunfalg = false
			},
			
			
			barfun(e){
				if(e==0){
					window.open('https://www.720yun.com/vr/182jO7kkva8',"_blank");
				}
				if(e==1){
					if(this.$route.name == 'scenic'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'scenic',query:{nums:0}})
					}
				}
				if(e==2){
					if(this.$route.name == 'scenery'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'scenery',query:{nums:0}})
					}
				}
				if(e==3){
					if(this.$route.name == 'service'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'service',query:{nums:0}})
					}
				}
				if(e==4){
					if(this.$route.name == 'contact'){
										this.$router.replace('/refresh')
					}else{
										this.$router.push({name:'contact',query:{nums:0}})
					}
				}
			},
			
		}
	}
</script>

<style scoped lang="less">
	//
	.bar{
		height: 116px;
		width: 1920px;
		position: absolute;
		z-index: 10;
		bottom: 0;
		left: 0;
		background-image: url('../static/home/bar.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		Box-shadow: 0px 0px 30px 0px #ededed;
		display: flex;
		font-family: "微软雅黑";
		color: #000000;
	}
	.bar_logo{
		height: 98px;
		width: 98px;
		margin: 11px 12px 0 70px;
		.bar_logo_img{
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	
	.bar_text{
		width: 750px;
		margin-top: 12px;
		
	}
	.bar_name{
		font-size: 20px;
		line-height: 20px;
		font-weight: 600;
	}
	.bar_option{
		margin-top: 9px;
		height: 15px;
		line-height: 15px;
		font-size: 14px;
		display: flex;
	}
	.bar_minopt{
		height: 15px;
		line-height: 15px;
		font-size: 14px;
		padding: 0 5px 0 0;
		margin-right: 5px;
		border-right: 2px solid #000000;
		cursor:pointer;
	}
		.bar_minopt:last-child{
			border-right: 2px solid transparent;
		}
	.bar_website{
		margin-top: 10px;
		font-size: 15px;
		height: 19px;
		line-height: 15px;
		color: #666666;
	}
	.bar_jszc{
		font-size: 15px;
		color: #666666;
		cursor:pointer;
	}
	.bar_phone{
		width: 850px;
		margin-top: 17px;
		text-align: right;
		margin-right: 20px;
	}
	.bar_ertextbox{
		display: flex;
		justify-content: flex-end;
	}
	.bar_ertext{
		height: 17px;
		line-height: 17px;
		font-size: 16px;
		font-weight: bold;
	}
	.san{
		height: 17px;
	}
	.bar_address{
		font-size: 14px;
		line-height: 14px;
		margin-top: 10px;
	}
	.bar_phone_num{
		margin-top: 5px;
		line-height: 14px;
		display: flex;
		justify-content: flex-end;
	}
	.bar_phone_box{
		font-size: 14px;
		line-height: 14px;
		padding-right: 4px;
		margin-right: 4px;
		border-right: 2px solid #000000;
	}
	.bar_phone_box_z{
		font-size: 14px;
	}
	.bar_supervise{
		font-size: 14px;
		margin-top: 10px;
	}
	.bar_er{
		width: 91px;
		height: 91px;
		margin-top: 14px;
		margin-right: 16px;
		border: 1px solid #a6a6a6;
	}
	.bar_erimg{
		width: 91px;
		height: 91px;
	}
	
	
	//
	.riesun{
		position: fixed;
		z-index: 100;
		top: 0;
		left: 0;
		width: 1920px;
		height: 100vh;
		background-color: rgba(0, 0, 0, .5);
	}
	.riesun_box{
		width: 1000px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform:translate(-50%,-50%);
		background-color: #363636;
	}
	.riesun_img{
		width: 100%;
	}
</style>